module.exports = __webpack_public_path__ + "static/media/cec-logo-2023.917ac669.png";